// @ts-nocheck
import { toast } from 'sonner';

export function showSuccess(title = '', msg = 'Saved') {
  toast.success(msg);
}

export function showError(title = '', msg = 'Error') {
  toast.error(msg);
}
